@if (items && items.length) {
  @if (shouldRender) {
    <mb-slider-base
      [itemsToSlide]="3"
      [itemsToShow]="3"
      [items]="items"
      [config]="config"
      containerClass="container-sm"
      #slider
      (indexChanged)="indexChanged.emit($event)"
    >
      <ng-template #itemTemplate let-item="item" let-index="index">
        @if (item.link) {
          @switch (item.link.type) {
            @case (linkTypes.ROUTER) {
              <a draggable="false" class="card-container" [routerLink]="item.link.url">
                <ng-container *ngTemplateOutlet="cardTemplate"></ng-container>
              </a>
            }
            @case (linkTypes.PROGRAMMATIC) {
              <a draggable="false" class="card-container" (click)="linkAction($event, item)">
                <ng-container *ngTemplateOutlet="cardTemplate"></ng-container>
              </a>
            }
            @case (linkTypes.EXTERNAL) {
              <a draggable="false" class="card-container" [href]="item.link.url" [target]="item.link.target">
                <ng-container *ngTemplateOutlet="cardTemplate"></ng-container>
              </a>
            }
            @case (linkTypes.NONE) {
              <div class="card-container">
                <ng-container *ngTemplateOutlet="cardTemplate"></ng-container>
              </div>
            }
            @default {
              <div class="card-container">
                <ng-container *ngTemplateOutlet="cardTemplate"></ng-container>
              </div>
            }
          }
        } @else {
          <ng-container *ngTemplateOutlet="cardTemplate"></ng-container>
        }
        <ng-template #cardTemplate>
          <mb-card-hero
            [data]="item"
            alignContent="top"
            [sperateFooter]="true"
            fuelLabelPosition="bottom"
            (click)="openCardMedia(item)"
          >
            @if (item.media) {
              <figure media>
                <mb-media [media]="item.media" [hoverplay]="true"></mb-media>
              </figure>
            }

            @if (item.actions && item.actions.length) {
              <mb-action-container
                action-container
                [buttonItems]="item.actions"
                [resource]="item"
              ></mb-action-container>
            }
          </mb-card-hero>
        </ng-template>
      </ng-template>
    </mb-slider-base>
  } @else {
    <div class="placeholder-container container-sm">
      <div class="row">
        <div class="col col-{{ 12 / itemsToShow }}">
          <div class="placeholder-item" [style.aspect-ratio]="ratio"></div>
        </div>
      </div>
    </div>
  }
}
